(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-chat-host-profile-card/assets/javascripts/bingo-chat-host-profile-card.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-chat-host-profile-card/assets/javascripts/bingo-chat-host-profile-card.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const Image = svs.content.image_v2.Image;
const BingoWrapperPaper = svs.bingo_react.components.bingoWrapperPaper.BingoWrapperPaper;
const BingoChatHostCard = _ref => {
  let chatHost = _ref.chatHost;
  return React.createElement(BingoWrapperPaper, null, React.createElement("article", {
    className: "bingo-chat-host-profile-card"
  }, React.createElement("div", {
    className: "bingo-chat-host-profile-card__profile"
  }, React.createElement("div", {
    className: "bingo-chat-host-profile-card__profile-picture-wrapper"
  }, React.createElement(Image, {
    cssSelectors: "bingo-chat-host-profile-card__profile-picture",
    fitWrapper: true,
    image: _objectSpread(_objectSpread({}, chatHost.profilePicture), {}, {
      fitWrapper: true,
      aspectRatio: {
        height: 720,
        width: 1040
      }
    })
  })), React.createElement("h4", {
    className: "h2 bingo-chat-host-profile-card__profile-name"
  }, chatHost.name)), React.createElement("p", {
    className: "bingo-chat-host-profile-card__description"
  }, chatHost.description), React.createElement("div", {
    className: "bingo-chat-host-profile-card__tags"
  }, chatHost.tags.map(_ref2 => {
    let tag = _ref2.tag;
    return React.createElement("span", {
      className: "bingo-chat-host-profile-card__tag",
      key: tag
    }, tag);
  }))));
};
setGlobal('svs.bingo_react.components.bingoChatHostCard.BingoChatHostCard', BingoChatHostCard);

 })(window);